import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authlog } from 'AuthLogger';
import { removeCmSessionData } from 'features/creditMonitoring/CreditAccessHelpers';

import { IAuthState, SessionState } from './auth.types';

const initialState: IAuthState = {
  requestState: { originUrl: undefined, loginCount: 0, isCustomPopup: false },
  loginRedirectSuccess: false,
  useDefaultScope: false,
  sessionState: SessionState.Unknown,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    onLoginRedirectSuccess: (state, action: PayloadAction<IAuthState>) => {
      state.requestState.loginCount = action.payload.requestState.loginCount;
      state.requestState.originUrl = action.payload.requestState.originUrl;
      state.loginRedirectSuccess = true;
      state.useDefaultScope = action.payload.useDefaultScope ?? false;
    },
    setUseDefaultScope: (state, action: PayloadAction<boolean>) => {
      state.useDefaultScope = action.payload;
    },
    setSessionState: (state, action: PayloadAction<SessionState>) => {
      authlog(`authSlice: setSessionState -> ${action.payload}`);
      state.sessionState = action.payload;

      if (state.sessionState === SessionState.Locked) {
        authlog('authSlice: removes session data');
        removeCmSessionData();
      }
    },
    resetAuthStates: (state) => {
      state.requestState.originUrl = undefined;
      state.requestState.loginCount = 0;
      state.requestState.isCustomPopup = false;
      state.loginRedirectSuccess = false;
      state.useDefaultScope = false;
    },
  },
});

export const { onLoginRedirectSuccess, setUseDefaultScope, setSessionState, resetAuthStates } = authSlice.actions;

export default authSlice.reducer;
